let timeFieldNowOrLater = () => {
  return {
      restrict: 'A',
      scope: {
        sbDate: '@'
      },
      require: 'ngModel',
      link: (scope, element, attrs, ngModelController) => {
        ngModelController.$validators.timeFieldNowOrLater = function(modelValue, viewValue) {
          if (ngModelController.$isEmpty(modelValue) === true) {
              return true;
          }

          let sbDate = scope.sbDate.replace(/\"/g, '');

          let date = moment(sbDate);

          let datetimeText = date.format('YYYY-MM-DD');

          datetimeText += ' ' + modelValue;

          let datetime = moment(datetimeText);

          return datetime.isValid() && datetime.isSameOrAfter(moment());
        }
      }
  };
};

timeFieldNowOrLater.$inject = [];

export default timeFieldNowOrLater;



// WEBPACK FOOTER //
// ./client/app/common/field-validators/time-field-now-or-later.js